module.exports = __webpack_public_path__ + "static/media/app_store.e374ae72.svg";